<template>
  <v-main class="content">
      <router-view />
  </v-main>
</template>

<script>
export default {
    name: "DefaultView",
};
</script>

<style scoped>

@media (max-width: 908px) {
  .content {
    width: 100%;
  }
}

</style>